import { useEffect } from "react";

const AccessSideDrawer = ({action, employee, onClose}) => {

    useEffect(() => {
console.log(action, employee);
    }, [])

    return (
        <>
           <div className="ov " id="ov" ></div>

  <aside
    className={`drawer ${action === 'roles' ? 'show' : ''}`}
    id="drawer"
    aria-hidden="false"
  >
    <div className="dhd">
      <div className="dhd-info">
        <div className="eb" id="dEb">Roles</div>
        <h2 id="dTitle">Rajesh Kumar</h2>
        <div className="ds" id="dSub">
          Tick the roles assigned to this person
        </div>
      </div>

      <button className="xc" onClick={() => {onClose()}}>×</button>
    </div>

    <div id="dSeg"></div>

    <div className="dsearch" id="dSearchWrap">
      <input
        id="dSearch"
        placeholder="Search…"
        
      />
    </div>

    <div id="dNote"></div>

    <div className="dbody" id="dBody">
      <label className="chk on">
        <span className="box">
          <svg viewBox="0 0 24 24">
            <path d="M20 6L9 17l-5-5"></path>
          </svg>
        </span>
        <span className="ci">
          <span className="cn">Sales Executive</span>
          <span className="cd">Front-line sales</span>
        </span>
      </label>

      <label className="chk">
        <span className="box">
          <svg viewBox="0 0 24 24">
            <path d="M20 6L9 17l-5-5"></path>
          </svg>
        </span>
        <span className="ci">
          <span className="cn">Team Leader</span>
          <span className="cd">Leads a sales team</span>
        </span>
      </label>

      <label className="chk">
        <span className="box">
          <svg viewBox="0 0 24 24">
            <path d="M20 6L9 17l-5-5"></path>
          </svg>
        </span>
        <span className="ci">
          <span className="cn">Booking Desk</span>
          <span className="cd">Handles bookings &amp; registry</span>
        </span>
      </label>

      <label className="chk">
        <span className="box">
          <svg viewBox="0 0 24 24">
            <path d="M20 6L9 17l-5-5"></path>
          </svg>
        </span>
        <span className="ci">
          <span className="cn">Manager</span>
          <span className="cd">Full sales oversight</span>
        </span>
      </label>

      <label className="chk">
        <span className="box">
          <svg viewBox="0 0 24 24">
            <path d="M20 6L9 17l-5-5"></path>
          </svg>
        </span>
        <span className="ci">
          <span className="cn">Admin</span>
          <span className="cd">System administrator</span>
        </span>
      </label>
    </div>

    <div className="dft">
      <div className="cnt" id="dCount">
        <b>1</b> roles selected
      </div>

      <button className="btn btn-outline-p" >
        Done
      </button>

      <button className="btn btn-p" >
        Save
      </button>
    </div>
  </aside>


  
<aside className={`drawer ${action === 'permission' ? 'show' : ''}`} id="drawer" aria-hidden="false">
  <div className="dhd">
    <div className="dhd-info">
      <div className="eb" id="dEb">Permissions</div>
      <h2 id="dTitle">Rajesh Kumar</h2>
      <div className="ds" id="dSub">
        Direct grants (role-inherited shown as “via role”, locked)
      </div>
    </div>

    <button className="xc" onClick={() => {onClose()}}>×</button>
  </div>

  <div id="dSeg"></div>

  <div className="dsearch" id="dSearchWrap">
    <input
      id="dSearch"
      placeholder="Search…"
      
    />
  </div>

  <div id="dNote"></div>

  <div className="dbody" id="dBody">
    <div className="dcat">Contacts</div>

    <label className="chk on locked">
      <span className="box">
        <svg viewBox="0 0 24 24">
          <path d="M20 6L9 17l-5-5"></path>
        </svg>
      </span>
      <span className="ci">
        <span className="cn">
          Contact.View<span className="pill">via role</span>
        </span>
        <span className="cd">View contacts in own hierarchy</span>
      </span>
    </label>

    <label className="chk on locked">
      <span className="box">
        <svg viewBox="0 0 24 24">
          <path d="M20 6L9 17l-5-5"></path>
        </svg>
      </span>
      <span className="ci">
        <span className="cn">
          Contact.Create<span className="pill">via role</span>
        </span>
        <span className="cd">Add and edit contacts</span>
      </span>
    </label>

    <label className="chk">
      <span className="box">
        <svg viewBox="0 0 24 24">
          <path d="M20 6L9 17l-5-5"></path>
        </svg>
      </span>
      <span className="ci">
        <span className="cn">Contact.All</span>
        <span className="cd">See every contact across the org</span>
      </span>
    </label>

    <label className="chk">
      <span className="box">
        <svg viewBox="0 0 24 24">
          <path d="M20 6L9 17l-5-5"></path>
        </svg>
      </span>
      <span className="ci">
        <span className="cn">Contact.Export</span>
        <span className="cd">Export contact lists</span>
      </span>
    </label>

    <div className="dcat">Deals</div>

    <label className="chk on locked">
      <span className="box">
        <svg viewBox="0 0 24 24">
          <path d="M20 6L9 17l-5-5"></path>
        </svg>
      </span>
      <span className="ci">
        <span className="cn">
          Deal.Manage<span className="pill">via role</span>
        </span>
        <span className="cd">Create, edit and move deals</span>
      </span>
    </label>

    <label className="chk">
      <span className="box">
        <svg viewBox="0 0 24 24">
          <path d="M20 6L9 17l-5-5"></path>
        </svg>
      </span>
      <span className="ci">
        <span className="cn">Deal.Delete</span>
        <span className="cd">Delete deals</span>
      </span>
    </label>

    <div className="dcat">Bookings</div>

    <label className="chk on locked">
      <span className="box">
        <svg viewBox="0 0 24 24">
          <path d="M20 6L9 17l-5-5"></path>
        </svg>
      </span>
      <span className="ci">
        <span className="cn">
          Booking.Create<span className="pill">via role</span>
        </span>
        <span className="cd">Create bookings and pricing</span>
      </span>
    </label>

    <label className="chk">
      <span className="box">
        <svg viewBox="0 0 24 24">
          <path d="M20 6L9 17l-5-5"></path>
        </svg>
      </span>
      <span className="ci">
        <span className="cn">Booking.Registry</span>
        <span className="cd">Update registry &amp; KYC status</span>
      </span>
    </label>

    <div className="dcat">Projects</div>

    <label className="chk">
      <span className="box">
        <svg viewBox="0 0 24 24">
          <path d="M20 6L9 17l-5-5"></path>
        </svg>
      </span>
      <span className="ci">
        <span className="cn">Project.Manage</span>
        <span className="cd">Manage projects, towers &amp; units</span>
      </span>
    </label>

    <div className="dcat">Reports</div>

    <label className="chk on locked">
      <span className="box">
        <svg viewBox="0 0 24 24">
          <path d="M20 6L9 17l-5-5"></path>
        </svg>
      </span>
      <span className="ci">
        <span className="cn">
          Report.View<span className="pill">via role</span>
        </span>
        <span className="cd">View dashboards &amp; reports</span>
      </span>
    </label>

    <label className="chk">
      <span className="box">
        <svg viewBox="0 0 24 24">
          <path d="M20 6L9 17l-5-5"></path>
        </svg>
      </span>
      <span className="ci">
        <span className="cn">Report.Export</span>
        <span className="cd">Export reports to Excel/PDF</span>
      </span>
    </label>

    <div className="dcat">Admin</div>

    <label className="chk">
      <span className="box">
        <svg viewBox="0 0 24 24">
          <path d="M20 6L9 17l-5-5"></path>
        </svg>
      </span>
      <span className="ci">
        <span className="cn">Admin.Access</span>
        <span className="cd">Manage users, roles &amp; settings</span>
      </span>
    </label>
  </div>

  <div className="dft">
    <div className="cnt" id="dCount">
      <b>5</b> permissions selected
    </div>

    <button className="btn btn-outline-p" >Done</button>

    <button className="btn btn-p">Save</button>
  </div>
</aside>


  <div className="toast" id="toast">
    <span className="dot"></span>
    <span id="toastMsg"></span>
  </div>
        </>
    )
}

export default AccessSideDrawer;